import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api, { fileUrl } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function MediaPicker({ open, onClose, onSelect }) {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    if (!open) return;
    api.get("/admin/media").then(({ data }) => setItems(data)).catch(() => {});
  }, [open]);
  const filtered = q ? items.filter((m) => m.name.toLowerCase().includes(q.toLowerCase())) : items;
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-3xl" data-testid="media-picker">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Choose from Media Library</DialogTitle>
        </DialogHeader>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name…" data-testid="media-picker-search" />
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 max-h-[55vh] overflow-y-auto pr-1">
          {filtered.map((m) => (
            <button
              key={m.id}
              type="button"
              onClick={() => { onSelect(m.url); onClose(); }}
              className="group text-left border border-zinc-200 rounded-md overflow-hidden hover:border-zinc-900 transition-colors"
              data-testid={`media-picker-item-${m.id}`}
            >
              <div className="aspect-[4/3] bg-zinc-100">
                <img src={`${fileUrl(m.url)}${m.updated_at ? `?v=${encodeURIComponent(m.updated_at)}` : ""}`} alt={m.name} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <div className="px-2 py-1.5 text-[11px] truncate">{m.name}</div>
            </button>
          ))}
          {filtered.length === 0 && <div className="col-span-full py-10 text-center text-sm text-zinc-400">No photos found</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
